var locale = {
  placeholder: 'انتخاب زمان',
  rangePlaceholder: ['زمان شروع', 'زمان پایان']
};
export default locale;